import { render, staticRenderFns } from "./ModoAcaoForm.vue?vue&type=template&id=e3c0895a&"
import script from "./ModoAcaoForm.vue?vue&type=script&lang=js&"
export * from "./ModoAcaoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports